module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAABSUlEQVRYR+2VSW7CQBBFq4A7sGEfDBJ44cAdEMOBoiiBEyGGM0SKLYFZICTWJNyB0IWMYmQwUN2eemNv3XY/13/9jaD5Qs37Qw6QTwDXpvWmU0TcmO2BIDHWAYEE/bMDm+brSAC8ZwmBiENj+f15kXDdaM0BqZMRxKzm2j1vrwvAttGuHFA4AFBOGeK3UPizqovFzxXAOYoMfPByN1b21P/IUA+k6YOfe3DCd4soDR8QYGb8584CpODDVe4sQNI+3OYuBZBUP9zLXRrAWxjPB5rXXKf77Fizf8OoPhDB/oAly3S/drEAovpARIP6yplwpcZOwH+BSj8QwKju2h/c5qEm5B6Q84HPXUnC4GIJH/ZFKFkvTO6RATgfZHOPBfCoH1Ryjw0Q7ge13BMBCPhAqrknAuD7cBRHkjnvj06YdA9wRzTq/RxA+wROcxCmXU85780AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/imgs/kfc/down-kfc.png
// module id = O9UO
// module chunks = 1